import React, { Component, useState } from "react";
import { Link, useHistory, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  message,
} from "antd";
import signinbg from "../assets/images/sign-in-bg.jpg";
import {
  EyeTwoTone,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import logo from '../assets/images/logo.png';
import Post from '../services/Post';
import OTPInput from "otp-input-react";

function onChange(checked) {
  console.log(`switch to ${checked}`);
}
const { Title } = Typography;
const { Header, Footer, Content } = Layout;

const SignIn = () => {
  const [formType, setFormType] = useState('mobile');
  const [mobileNumber, setMobileNumber] = useState();
  const [verifyId, setVerifyId] = useState();
  const [verifyType, setVerifyType] = useState();
  const [loading, setLoading] = useState(false);
  const [OTP, setOTP] = useState();

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const refer_code = searchParams.get('refer');
  const prevUrl = location.state?.prevUrl;

  const onFinish = (values) => {
    setLoading(true);
    if (formType === 'mobile') {
      Post.Login({ mobile: values.mobile })
        .then((res) => {
          if (res.success) {
            console.log(res);
            setMobileNumber(values.mobile);
            setVerifyType(res.type);
            setVerifyId(res.id);
            setFormType("otp");
          } else {
            console.error("Login failed");
            message.error("Something went wrong!");
          }
        })
        .finally(() => setLoading(false));
    } else {
      let value;
      if (verifyType == 'otp') {
        value = OTP;
      } else {
        value = values.password;
      }
      Post.VerifyOtp({ value, id: verifyId, type: verifyType })
        .then((res) => {
          if (res.error) {
            console.error(res.error);
            message.error(res.error);
          }
          if (res.success) {
            localStorage.setItem('user', JSON.stringify(res.data));
            if (prevUrl) {
              navigate(prevUrl);
            } else {
              navigate(res.userType === "old" ? "/user/home" : refer_code ? `/user/profile?refer=${refer_code}` : "/user/profile");
            }
          }
        })
        .finally(() => setLoading(false));
    }
  };

  const handleForgetPassword = () => {
    setLoading(true);
    Post.ForgotPassword({ mobile: mobileNumber })
      .then((res) => {
        if (res.success) {
          console.log(res);
          navigate("/forgot-password", { state: { id: res.id } });
        } else {
          message.error("Something went wrong");
        }
      })
      .finally(() => setLoading(false));
  }

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <Layout className="layout-default layout-signin">
        <Header>
          <div className="header-col header-brand header-logo" onClick={() => navigate("/")}>
            <img src={logo} alt="" height={70} />
          </div>
          {/* <div className="header-col header-nav">
              <Menu mode="horizontal" defaultSelectedKeys={["1"]}>
                <Menu.Item key="1">
                  <Link to="/dashboard">
                    <span> Dashboard</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="2">
                  <Link to="/profile">
                    {profile}
                    <span>Profile</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="3">
                  <Link to="/sign-up">
                    {signup}
                    <span> Sign Up</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="4">
                  <Link to="/sign-in">
                    {signin}
                    <span> Sign In</span>
                  </Link>
                </Menu.Item>
              </Menu>
            </div> */}
          {/* <div className="header-col header-btn">
              <Button type="primary">FREE DOWNLOAD</Button>
            </div> */}
        </Header>
        <Content className="signin">
          <Row gutter={[24, 0]} justify="space-around">
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 2 }}
              md={{ span: 12 }}
            >
              <Title className="mb-15">Sign In</Title>
              {formType === "mobile" ? (
                <>
                  <Title className="font-regular text-muted" level={5}>
                    Enter your Phone number to sign in
                  </Title>
                  <Form
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                    className="row-col"
                  >
                    <Form.Item
                      className="username"
                      label="Phone"
                      name="mobile"
                      rules={[
                        {
                          required: true,
                          message: "Please input your phone number!",
                        },
                      ]}
                    >
                      <Input placeholder="Phone Number" type="tel" maxLength={10} />
                    </Form.Item>

                    <Form.Item
                      name="remember"
                      className="align-center"
                      valuePropName="checked"
                    >
                      <Switch
                        defaultChecked
                        onChange={onChange}
                        style={{ backgroundColor: "#a6cc43" }}
                      />
                      Remember me
                    </Form.Item>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                          width: "100%",
                          backgroundColor: "#a6cc43",
                          borderColor: "#a6cc43",
                        }}
                        loading={loading}
                      >
                        SIGN IN
                      </Button>
                    </Form.Item>
                    {/* <p className="font-semibold text-muted">
                      Don't have an account?{" "}
                      <Link to="/sign-up" className="text-dark font-bold">
                        Sign Up
                      </Link>
                    </p> */}
                  </Form>
                </>
              ) : verifyType === "otp" ? (
                <>
                  <Title className="font-regular text-muted" level={5}>
                    Enter 6 digits OTP sent to your phone number
                  </Title>
                  <Form
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                    className="row-col"
                  >
                    <div className="otp-form">
                      <label>Enter OTP</label>
                      {/* <Form.List name="otp" initialValue={["", "", "", "", "", ""]}>
                        {(fields, { getFieldValue }) => (
                          <div style={{ display: "flex", gap: "10px" }}>
                            {fields.map((field, index) => (
                              <Form.Item
                                {...field}
                                key={index}
                                rules={[
                                  { required: true, message: "Please enter a digit" },
                                  { pattern: /^\d$/, message: "Enter a valid digit (0-9)" },
                                ]}
                              >
                                <Input
                                  maxLength={1}
                                  style={{ width: "40px", textAlign: "center" }}
                                  className={`otp otp-${index}`}
                                />
                              </Form.Item>
                            ))}
                          </div>
                        )}
                      </Form.List> */}

                      <OTPInput value={OTP} onChange={setOTP} autoFocus OTPLength={6} otpType="number" disabled={false} secure style={{ marginBottom: 20, padding: 10 }} />
                    </div>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                          width: "100%",
                          backgroundColor: "#a6cc43",
                          borderColor: "#a6cc43",
                        }}
                        loading={loading}
                      >
                        Submit OTP
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              ) : (
                <>
                  <Title className="font-regular text-muted" level={5}>
                    Enter your Password
                  </Title>
                  <Form
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                    className="row-col"
                  >
                    <Form.Item
                      className="username"
                      label="Password"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your password!",
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="Enter password"
                        iconRender={(visible) =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                      />
                    </Form.Item>

                    <Form.Item>
                      <Row justify={'end'} align="center">
                        <div onClick={handleForgetPassword} style={{ color: 'blue', cursor: 'pointer' }}>Forgot password</div>
                      </Row>
                    </Form.Item>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                          width: "100%",
                          backgroundColor: "#a6cc43",
                          borderColor: "#a6cc43",
                        }}
                        loading={loading}
                      >
                        SIGN IN
                      </Button>
                    </Form.Item>
                    {/* <p className="font-semibold text-muted">
                      Don't have an account?{" "}
                      <Link to="/sign-up" className="text-dark font-bold">
                        Sign Up
                      </Link>
                    </p> */}
                  </Form>
                </>
              )}
            </Col>

            <Col
              className="sign-img"
              style={{ padding: 12 }}
              xs={{ span: 24 }}
              lg={{ span: 12 }}
              md={{ span: 12 }}
            >
              <img src={signinbg} alt="" style={{width: '100%'}} />
            </Col>
          </Row>
        </Content>
        {/* <Footer>
          <Menu mode="horizontal">
            <Menu.Item>Company</Menu.Item>
            <Menu.Item>About Us</Menu.Item>
            <Menu.Item>Teams</Menu.Item>
            <Menu.Item>Products</Menu.Item>
            <Menu.Item>Blogs</Menu.Item>
            <Menu.Item>Pricing</Menu.Item>
          </Menu>
          <Menu mode="horizontal" className="menu-nav-social">
            <Menu.Item>
              <Link to="#">{<DribbbleOutlined />}</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="#">{<TwitterOutlined />}</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="#">{<InstagramOutlined />}</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="#">
                <svg
                  width="18"
                  height="18"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path d="M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"></path>
                </svg>
              </Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="#">{<GithubOutlined />}</Link>
            </Menu.Item>
          </Menu>
          <p className="copyright">
            {" "}
            Copyright © 2021 Muse by <a href="#pablo">Creative Tim</a>.{" "}
          </p>
        </Footer> */}
      </Layout>
    </>
  );
}

export default SignIn;